import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectIsAuthorized } from '../../../redux/authSlice';
import paths from '../../paths';

interface PublicRouteProps {
  component: ComponentType;
}

const PublicRoute = ({ component: Component }: PublicRouteProps) => {
  const isAuthorized = useSelector(selectIsAuthorized);

  if (isAuthorized) {
    return <Navigate to={paths.calculatorDashboard} replace />;
  }

  return <Component />;
};


export default PublicRoute;
